import { render, staticRenderFns } from "./TixPayment.vue?vue&type=template&id=444e8f74&"
import script from "./TixPayment.vue?vue&type=script&lang=ts&"
export * from "./TixPayment.vue?vue&type=script&lang=ts&"
import style0 from "./TixPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports